import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { FieldDef } from 'app/core/models';
import { Pipeline, Project, ProjectPagination } from 'app/modules/projects/projects.types';

@Component({
  selector: 'app-map-deal-list',
  templateUrl: './map-deal-list.component.html',
  styleUrls: ['./map-deal-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapDealListComponent extends OnDestroyMixin {
  @Input() pipeline: Pipeline;
  @Input() projects: Project[];
  @Input() pagination: ProjectPagination;
  @Input() sortFields: FieldDef[];
  @Input() isLoading: boolean;
  @Input() selectedSortField: string;

  @Output() onSelectSortOption = new EventEmitter<FieldDef>();
  @Output() onPageChange = new EventEmitter<'next' | 'previous'>();

  get showPagingControls(): boolean {
    return this.pagination.length > this.pageSize;
  }

  get canGoToNextPage(): boolean {
    return this.pagination.page + 1 === this.pagination.lastPage;
  }

  get canGoToPreviousPage(): boolean {
    return this.pagination.page === 0;
  }

  private get pageSize(): number {
    return this.pagination?.size;
  }

  constructor() {
    super();
  }

  changePage(value: 'next' | 'previous'): void {
    this.onPageChange.emit(value);
  }

  changeSortOptions({ value }: MatSelectChange): void {
    const fieldDef = this.sortFields.find(({ name }) => name === value);

    if (fieldDef) {
      this.onSelectSortOption.emit(fieldDef);
    }
  }
}
